var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Block } from '@syllepsis/adapter';
import { Selection } from 'prosemirror-state';
import { DEFAULT_LANGUAGE, transformToShow } from './utils';
import { CodeBlockView } from './view';
// insert break after <code>
var formatCodeDOMStructure = function (dom) {
    var codeTags = Array.prototype.slice.call(dom.querySelectorAll('code'));
    var spans = Array.prototype.slice.call(dom.querySelectorAll('span'));
    codeTags.forEach(function (code, idx) {
        if (idx === codeTags.length - 1)
            return;
        code.appendChild(document.createElement('br'));
    });
    spans.forEach(function (span) {
        if (/\u200B/.test(span.innerText)) {
            span.innerText = span.innerText.replace(/\u200B/g, '');
        }
    });
};
var arrowHandler = function (dir) { return function (editor, state, dispatch, view) {
    if (state.selection.empty && view.endOfTextblock(dir)) {
        var side = dir === 'left' || dir === 'up' ? -1 : 1;
        var $head = state.selection.$head;
        var nextPos = Selection.near(state.doc.resolve(side > 0 ? $head.after() : $head.before()), side);
        if (nextPos.$head && nextPos.$head.parent.type.name === 'code_block') {
            dispatch(state.tr.setSelection(nextPos));
            return true;
        }
    }
    return false;
}; };
var CodeBlock = /** @class */ (function (_super) {
    __extends(CodeBlock, _super);
    function CodeBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'code_block';
        _this.tagName = function () { return 'pre'; };
        _this.code = true;
        _this.notLastLine = true;
        _this.marks = '';
        _this.attrs = {
            language: {
                default: DEFAULT_LANGUAGE,
            },
        };
        _this.textMatcher = [
            {
                matcher: /^```([^\s]*)\s$/,
                handler: function (match) {
                    return {
                        language: transformToShow(match[1]),
                    };
                },
            },
            {
                matcher: /^```([^\s]*)$/,
                timing: 'enter',
                handler: function (match) {
                    return {
                        language: transformToShow(match[1]),
                    };
                },
            },
        ];
        _this.content = 'text*';
        _this.parseDOM = [
            {
                tag: 'pre',
                preserveWhitespace: 'full',
                getAttrs: function (dom) {
                    var parentElement = dom.parentElement;
                    if (!parentElement || !parentElement.classList.contains('code-snippet__js')) {
                        formatCodeDOMStructure(dom);
                    }
                    if (dom.querySelector('.ace-line')) {
                        // docs(ace-editor) remove the useless last <br>
                        var lastBr = Array.prototype.slice.call(dom.querySelectorAll('br')).pop();
                        if (lastBr && lastBr.parentElement) {
                            lastBr.parentElement.removeChild(lastBr);
                        }
                    }
                    // jianshu remove the useless last line
                    var lineDOM = dom.querySelector('.line-numbers-rows');
                    if (lineDOM &&
                        lineDOM.previousSibling &&
                        lineDOM.previousSibling.textContent === '\n' &&
                        lineDOM.parentElement) {
                        lineDOM.parentElement.removeChild(lineDOM.previousSibling);
                    }
                    return getAttrs(dom);
                },
            },
            {
                tag: 'div.CodeMirror',
                preserveWhitespace: 'full',
                getAttrs: function (dom) {
                    // CodeMirror structure <div><pre></pre></div>, .CodeMirror-linenumber for line number，pre for single line
                    var preTags = Array.prototype.slice.call(dom.querySelectorAll('pre'));
                    var orderDOMs = Array.prototype.slice.call(dom.querySelectorAll('.CodeMirror-linenumber'));
                    preTags.forEach(function (pre, idx) {
                        if (idx === preTags.length - 1)
                            return;
                        pre.appendChild(document.createTextNode('br'));
                    });
                    orderDOMs.forEach(function (_dom) {
                        if (_dom.parentElement) {
                            _dom.parentElement.removeChild(_dom);
                        }
                    });
                    return getAttrs(dom);
                },
            },
            {
                tag: 'p[code_block]',
                preserveWhitespace: 'full',
                getAttrs: getAttrs,
            },
            {
                tag: 'section.code-snippet__js',
                preserveWhitespace: 'full',
                getAttrs: function (dom) {
                    // wechat code_block structure <section><ul></ul><pre><code></code></pre></section>, <ul> for line number，<code> for single row
                    var preDOM = dom.querySelector('pre');
                    if (!preDOM)
                        return false;
                    var orderDOM = dom.querySelector('ul');
                    if (orderDOM)
                        dom.removeChild(orderDOM);
                    formatCodeDOMStructure(dom);
                    return getAttrs(preDOM);
                },
            },
        ];
        _this.defining = true;
        _this.NodeView = CodeBlockView;
        _this.toDOM = function (node) {
            return ['pre', { language: node.attrs.language, code_block: true }, ['code', 0]];
        };
        return _this;
    }
    CodeBlock.keymap = {
        ArrowLeft: arrowHandler('left'),
        ArrowRight: arrowHandler('right'),
        ArrowUp: arrowHandler('up'),
        ArrowDown: arrowHandler('down'),
    };
    return CodeBlock;
}(Block));
function getAttrs(dom) {
    var language = dom.getAttribute('language');
    if (!language) {
        var wrapper = dom.querySelector('[language]');
        language = (wrapper && wrapper.getAttribute('language')) || DEFAULT_LANGUAGE;
    }
    return {
        language: transformToShow(language),
    };
}
export { CodeBlock };
//# sourceMappingURL=schema.js.map